import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-omni-messaging-system-event',
  templateUrl: './system-event.component.html',
  styleUrls: ['./system-event.component.scss'],
})
export class OmniMessagingSystemEventComponent {
  @Input() public message: string;
  @Input() public isTransferMessage: boolean;
  @Input() public shouldEnablePreChatWelcome: boolean;
}
